


















import Vue from 'vue';
import { assign } from 'lodash';

import { getQueryParams, setQueryParams, reload } from '@/utils';
import ZenModalWrapper from './ZenModalWrapper.vue';
import { Modal, ModalSize } from './types';

import 'custom-event-polyfill';
import 'url-search-params-polyfill';

export default Vue.extend({
  name: 'ZenModalTrigger',
  components: {
    ZenModalWrapper,
  },
  data() {
    return {
      modals: <Modal[]>[],
      reloadPage: <boolean>false,
      cacheOn: <number | false>false,
      cacheTypes: <string[]>[],
    };
  },
  computed: {
    activeModal(): Modal {
      return this.modals[this.modals.length - 1];
    },
    ignoreUrl() {
      return this.activeModal && this.activeModal.config && this.activeModal.config.ignoreUrl;
    },
    visible(): boolean {
      return this.modals.length > 0;
    },
    size(): ModalSize {
      if (this.activeModal.config && this.activeModal.config.size) {
        return this.activeModal.config.size;
      } else {
        return ModalSize.Medium;
      }
    },
  },
  watch: {
    modals: 'updateUrl',
  },
  created() {
    // TODO: temporary solution for bringing this into SPA
    window.GGRC = window.GGRC || {};
    window.GGRC.zenModal = this;
    window.GGRC.zenModalContext = window.GGRC.zenModalContext || {};

    this.parseUrl();
    this.$on('reloadPage', () => (this.reloadPage = true));
  },
  methods: {
    getQueryParams,
    setQueryParams,
    reload,
    confirm(message?: string, title?: string): Promise {
      this.showAndSaveState({
        id: Math.random(),
        type: 'GenericConfirm',
        data: {
          message,
          title,
        },
        config: { ignoreUrl: true },
      });

      return new Promise(resolve => {
        this.$once('confirmation', resolve);
      });
    },
    show(modal: Modal) {
      modal.id = modal.id || Math.random();
      this.modals.push(modal);
    },
    showAndSaveState(modal: Modal) {
      // Use this functionality only when necessary!
      modal.id = modal.id || Math.random();

      // Set flag when cache was enabled
      if (!this.cacheOn) {
        this.cacheOn = modal.id;
        if (this.activeModal) {
          this.cacheTypes = [this.activeModal.type];
        }
      }

      this.$nextTick(() => this.show(modal));
    },
    hide() {
      const disableCache = this.activeModal.id === this.cacheOn;
      this.modals.pop();
      this.$emit('hide');

      this.$nextTick(() => {
        // Disable cache when flag reached or no modals
        if (!this.activeModal || disableCache) {
          this.cacheOn = false;
          this.cacheTypes = [];
        }
      });
    },
    hideAll() {
      const modalsToHide = this.modals.length;
      for (let i = 0; i < modalsToHide; i++) {
        this.hide();
      }
    },
    updateModal(property: string, newValue: object, replace = false) {
      const newModal = JSON.parse(JSON.stringify(this.activeModal));
      if (newValue !== null && newValue !== undefined) {
        if (replace) {
          newModal[property] = newValue;
        } else {
          newModal[property] = assign(newModal[property], newValue);
        }
      } else {
        delete newModal[property];
      }
      this.$set(this.modals, this.modals.length - 1, newModal);
    },
    updateUrl() {
      if (this.ignoreUrl) return;

      const params = new URLSearchParams(this.getQueryParams());

      if (this.modals.length > 0) {
        params.set(
          'zenModals',
          JSON.stringify(
            // Remove id from URL
            this.modals.map(({ id, ...modal }) => modal)
          )
        );
      } else {
        params.delete('zenModals');
      }

      this.setQueryParams(params.toString());
      // Reload the page if it was requested by any modal
      this.checkForReload();
    },
    parseUrl() {
      const params = new URLSearchParams(this.getQueryParams());
      if (params.has('zenModals')) {
        this.modals = JSON.parse(params.get('zenModals') as string).map((modal: Modal) => {
          modal.id = Math.random();
          return modal;
        });
      }
    },
    checkForReload() {
      if (this.modals.length === 0 && this.reloadPage) {
        // TODO: temporary solution for bringing this into SPA
        if (!this.$router) {
          // Trigger scroll position save before reloading
          document.dispatchEvent(new CustomEvent('reloadPage'));
          this.reload();
        } else {
          this.$emit('reloadData');
        }
      }
    },
  },
});
